import { BodyOf, Messages, ResponseOf } from "../../core/api";

export type NursingQuestion = Messages["NursingQuestionWithSettings"];
export type NursingQuestionAnswerType = NursingQuestion["answerType"];
export type NursingQuestionPossibleAnswer = Messages["NursingQuestionPossibleAnswer"];
export type NursingQuestionsSettingsResponse = ResponseOf<"get", "./nursing_questions_settings">;
export type NursingQuestionEditParams = BodyOf<
  "put",
  "./nursing_questions_settings/:nursingQuestionId"
>;

export const ANSWER_TYPE_LABELS: Record<NursingQuestionAnswerType, string> = {
  radio: "Radio",
  check: "Multiple Select (check)",
  dropDown: "Drop Down",
  yesNo: "Yes/No",
  textShort: "Short Text",
  textLong: "Long Text",
  number: "Number",
  time: "Time",
  date: "Date",
  bloodPressure: "Blood Pressure",
  RNPlatformPatientPhysician: "RN Platform Patient Physician",
  patientSignature: "Patient Signature",
  employeeSignature: "Employee Signature",
  customSignature: "Representative Signature",
  POC: "POC",
};

// The answer types offered when creating a new question (matches the legacy Angular modal).
export const CREATABLE_ANSWER_TYPES: NursingQuestionAnswerType[] = [
  "radio",
  "check",
  "dropDown",
  "yesNo",
  "textShort",
  "textLong",
  "number",
  "time",
  "date",
  "bloodPressure",
  "patientSignature",
  "employeeSignature",
];

export const MULTI_ANSWER_TYPES: NursingQuestionAnswerType[] = ["radio", "check", "dropDown"];
export const ALLOWED_VBP_TYPES: NursingQuestionAnswerType[] = ["radio", "dropDown", "yesNo"];
export const ALLOWED_SHOW_ON_AGENCY_TYPES: NursingQuestionAnswerType[] = [
  "radio",
  "check",
  "dropDown",
];
